/**
 * RukuNaSrce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NoteResponseDto } from './noteResponseDto';


export interface NoteResponseDtoPagedResponse { 
    results?: Array<NoteResponseDto> | null;
    totalResults?: number;
    page?: number;
    pageSize?: number;
    readonly totalPages?: number;
}

